// extracted by mini-css-extract-plugin
export var addButton = "_o4-0";
export var border = "_o4-8";
export var check = "_o4-h";
export var danger = "_o4-6";
export var dropdownContainer = "_o4-1";
export var editModalBody = "_o4-j";
export var footerContainer = "_o4-i";
export var fullWidth = "_o4-a";
export var hide = "_o4-9";
export var icon = "_o4-3";
export var input = "_o4-7";
export var inputFlex = "_o4-b";
export var inputWrapper = "_o4-c";
export var manualFocus = "_o4-5";
export var optionButton = "_o4-4";
export var pillWrapper = "_o4-e";
export var pointer = "_o4-2";
export var showOverflow = "_o4-f";
export var tagsFlex = "_o4-d";
export var xButton = "_o4-g";